import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RenovationViewsStaticsRules } from '../domain/constants/RenovationFieldsStaticsRules';
import { addToScan } from '../redux/scan/slice';
import { setCurrent } from '../redux/renovation/thunk';
import { RenovationKeyField } from '../domain/constants/RenovationField';

const useScan = () => {
  const [valueScannerPhysic, setValueScannerPhysic] = useState('');
  const renovation = useSelector((state: any) => state.renovation);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  const handleScan = (barcode: any) => {
    const letter =
      barcode.charAt(0).toLowerCase() === RenovationKeyField.prefix
        ? barcode.charAt(1)
        : barcode.charAt(3);
    const barcodeArray = barcode.split(letter);
    barcode = barcode.replaceAll(letter, '-');
    setValueScannerPhysic(barcode);
    dispatch(
      addToScan({
        barcode,
      })
    );
    const renovationCurrent =
      RenovationViewsStaticsRules[renovation.currentView];

    let enterFieldsSection = false;
    if (renovationCurrent.fields) {
      Object.keys(renovationCurrent.fields).forEach(async function (
        key: any,
        index
      ) {
        if (barcode === '-an-elar') {
          barcodeArray[0] = 'can';
        }

        if (
          renovationCurrent.fields &&
          renovationCurrent.fields[key].prefix === barcodeArray[0].toLowerCase()
        ) {
          enterFieldsSection = true;
          await dispatch(
            setCurrent({
              currentView: renovation.currentView,
              url: renovation.url,
              title: renovation.title,
              actionInProcess: true,
              process: {
                prefix: barcodeArray[0],
                barcode: barcode,
                id: barcodeArray[renovationCurrent.fields[key].positionValue],
              },
            })
          ).unwrap();
        }
      });
    }
    if (!enterFieldsSection) {
      setDestination(barcode, true);
    }
  };
  const handleError = (err: any) => {
    console.error(err);
  };

  const setDestination = (barcode: string, enabledRedirect: boolean) => {
    Object.keys(RenovationViewsStaticsRules).forEach(async function (
      key: any,
      index
    ) {
      if (RenovationViewsStaticsRules[key].barcode === barcode) {
        let respuesta = await dispatch(
          setCurrent({
            currentView: key,
            url: RenovationViewsStaticsRules[key].url,
            actionInProcess: false,
            process: undefined,
            title: RenovationViewsStaticsRules[key].title,
          })
        ).unwrap();
        if (enabledRedirect) {
          navigate(respuesta.renovation.url, { replace: true });
        }
      }
    });
  };

  return {
    valueScannerPhysic,
    handleScan,
    handleError,
    setDestination,
  };
};
export default useScan;
